module.exports = __webpack_public_path__ + "img/26.b34d8f70.jpg";